"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidPropNames = exports.checkEqualityAndMeasurePerf = exports.checkEquality = void 0;
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var pojoEqual = Object.is ||
    (function (x, y) {
        // SameValue algorithm
        if (x === y) {
            // Steps 1-5, 7-10
            // Steps 6.b-6.e: +0 != -0
            return x !== 0 || 1 / x === 1 / y;
        }
        // Step 6.a: NaN == NaN
        /* eslint-disable no-self-compare */
        return x !== x && y !== y;
        /* eslint-enable */
    });
function checkEquality(objA, objB, options) {
    if (immutable_1.isCollection(objA)) {
        if (immutable_1.is(objA, objB))
            return true;
        if (objA.count() !== objB.count()) {
            return false;
        }
        return true;
    }
    if (pojoEqual(objA, objB))
        return true;
    if (typeof objA !== 'object' ||
        objA === null ||
        typeof objB !== 'object' ||
        objB === null) {
        return false;
    }
    return checkObjectsEquality(objA, objB, 0, options);
}
exports.checkEquality = checkEquality;
function checkObjectsEquality(objA, objB, depthLevelParam, options) {
    var maxDepth = options.maxDepth, _a = options.excludedKeys, excludedKeys = _a === void 0 ? [] : _a, _b = options.debug, debug = _b === void 0 ? lodash_1.noop : _b;
    var depthLevel = depthLevelParam;
    if (depthLevel >= maxDepth)
        return false;
    depthLevel += 1;
    var debugNotEqual = function (key, a, b, isIgnored, isImmutable) {
        if (isIgnored === void 0) { isIgnored = false; }
        if (isImmutable === void 0) { isImmutable = false; }
        if (isIgnored) {
            debug("%c WAS IGNORED =>key: \"" + key + "\": %o", 'color: #fff; background: #FF7C00', [a[key], b[key]]);
        }
        else {
            debug("%c " + (isImmutable ? 'Immutable ' : '') + "NOT EQUAL, key: \"" + key + "\": %o", 'color: #fff; background: #e32121', [a[key], b[key]]);
        }
    };
    var initialKeysA = lodash_1.keys(objA);
    var keysB = lodash_1.keys(objB);
    if (initialKeysA.length !== keysB.length) {
        return false;
    }
    var keysA = lodash_1.filter(initialKeysA, function (key) {
        if (excludedKeys.includes(key)) {
            debugNotEqual(key, objA, objB, true);
            return false;
        }
        return true;
    });
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var _i = 0, keysA_1 = keysA; _i < keysA_1.length; _i++) {
        var keyInA = keysA_1[_i];
        if (!bHasOwnProperty(keyInA))
            return false;
        var propIsImmutable = immutable_1.isCollection(objA[keyInA]);
        if (propIsImmutable) {
            if (!immutable_1.is(objA[keyInA], objB[keyInA])) {
                debugNotEqual(keyInA, objA, objB);
                return false;
            }
        }
        else if (!pojoEqual(objA[keyInA], objB[keyInA])) {
            if (typeof objA[keyInA] === 'object' && objA[keyInA] != null) {
                if (!checkObjectsEquality(objA[keyInA], objB[keyInA], depthLevel, options)) {
                    debugNotEqual(keyInA, objA, objB);
                    return false;
                }
            }
            else {
                debugNotEqual(keyInA, objA, objB);
                return false;
            }
        }
    }
    return true;
}
function checkEqualityAndMeasurePerf(objA, objB, options) {
    var start = performance.now();
    var result = checkEquality(objA, objB, options);
    var stop = performance.now();
    var timeWasted = stop - start;
    if (timeWasted >= 4) {
        /* eslint-disable no-console */
        console.info("%c SLOW EQUALITY CHECK : \"" + (stop - start) + "\" : ", 'color: black; background: #12950A', [objA, objB]);
    }
    return result;
}
exports.checkEqualityAndMeasurePerf = checkEqualityAndMeasurePerf;
function isValidPropNames(props, propNames) {
    if (!props || lodash_1.isEmpty(props))
        return false;
    return lodash_1.every(propNames, function (propName) {
        var isValid = props[propName] != null;
        if (!isValid) {
            console.warn("property \"" + propName + "\" is not valid, abort \"" + name + "\" component render");
        }
        return isValid;
    });
}
exports.isValidPropNames = isValidPropNames;
//# sourceMappingURL=utils.js.map